import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import TextArea from 'components/TextArea';
import Dropdown from 'components/Dropdown';
import Checkbox from 'components/Checkbox';
import { Container, Head, Footer } from './styles';

const ModalGroupCancel = ({
  hidden,
  danger,
  singleBooking,
  buttonStyle,
  buttonLabel="Cancel Entire Group",
  setCancelRoomParams,
  setConfirmIsOpen,
  checkedIn,
  cancellationFeeAmount 
}) => {
  
  const [isOpen, setIsOpen] = useState(false)
  const [cancellationOption, setCancellationOption] = useState('') 
  const [cancellationReason, setCancellationReason] = useState('')  
  const [invalidateRoomCards, setInvalidateRoomCards] = useState(true)
  const [removeLodgingCharges, setRemoveLodgingCharges] = useState(true)
  const [removeMiscellaneousCharges, setRemoveMiscellaneousCharges] = useState(true)
  const [applyCancellationFee, setApplyCancellationFee] = useState(true)
  const [dropDownError, setDropDownError] = useState(false)
  const [textAreaError, setTextAreaError] = useState(false)

  const handleSubmit = () => {
    if(cancellationOption === "") {
      setDropDownError(true)
    } else if(cancellationOption === "Other" && !cancellationReason) {
      setTextAreaError(true)
    } else {
      setCancelRoomParams({
        cancellationReason: cancellationOption==='Other'? cancellationReason: cancellationOption,
        invalidateRoomCards: invalidateRoomCards,
        removeLodgingCharges: removeLodgingCharges,
        removeMiscellaneousCharges: removeMiscellaneousCharges,
        applyCancellationFee: applyCancellationFee,
      })
      setConfirmIsOpen(true)
      setIsOpen(false)
    }
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-danger"
      buttonLabel={buttonLabel}
      danger={danger}
      buttonStyle={buttonStyle}
      hidden={hidden}
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          .close {
            z-index: 200;
          }
          .modal-header {
            .modal-title {
              font-size: 22px;
              font-weight: 600;
            }
          }          
          .modal-body {
            height: 100%;
            padding: 24px;
          }
        }
        top: 136px;
      `}
    >
      <Head>{singleBooking? "Cancel this booking?" : "Cancel entire group?"}</Head>
      <Container>
        {checkedIn? (
          <div className="groupTitle">
            <span className='warning'>Warning: </span> This booking is currently checked in, are you sure you want to cancel?
          </div>
        ): (
          <div className="groupTitle">
            What is the reason for the cancellation?
          </div>
        )}
        <Dropdown
          title="REASON FOR CANCELLATION"
          options={[
            "Change of Plans",
            "Personal Reasons",
            "Found a Better Option",
            "Scheduling Conflict",
            "Health Issues",
            "Other",
          ]}
          error={dropDownError}
          value={cancellationOption}
          placeholder="-Select-"
          onChange={(e) => {
            setCancellationReason("");
            setCancellationOption(e);
            setDropDownError(false);
          }}
          additionalstyle={`
            width: 100%;
          `}
        />
        {cancellationOption === "Other" && (
          <TextArea
            title="TYPE A REASON HERE:"
            error={textAreaError}
            value={cancellationReason}
            onChange={(e) => {
              setCancellationReason(e.target.value);
              setTextAreaError(false);
            }}
            additionalstyle={`
            width: 100%;
            
            textarea {
              min-height: 54px;
              height: 54px;
            }
          `}
          />
        )}
        <div className="checkboxes">
          {checkedIn? (
            <Checkbox
            checked={invalidateRoomCards}
            onChange={() => setInvalidateRoomCards(!invalidateRoomCards)}
            title="Invalidate room cards"
          />
          ): null}
          <Checkbox
            checked={removeLodgingCharges}
            onChange={() => setRemoveLodgingCharges(!removeLodgingCharges)}
            title="Remove all lodging charges from bill"
          />
          <Checkbox
            checked={removeMiscellaneousCharges}
            onChange={() => setRemoveMiscellaneousCharges(!removeMiscellaneousCharges)}
            title="Remove all miscellaneous charges from bill"
          />
          <Checkbox
            checked={applyCancellationFee}
            onChange={() => setApplyCancellationFee(!applyCancellationFee)}
            title={`Add a cancellation fee to the bill ($${cancellationFeeAmount} in total)`}
          />
        </div>
      </Container>
      <Footer>
        <Button
          danger
          onClick={handleSubmit}
          additionalstyle={`
            width: 84px;
          `}
        >
          Submit
        </Button>
      </Footer>
    </MainModal>
  );
};

export default ModalGroupCancel;
